{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://forms/transfer-and-allocate",
  "title": "Transfer and Allocate",
  "description": "Create and edit transfer and allocate header fields.",
  "type": "object",
  "properties": {
    "id": {
      "$ref": "module://transfer-and-allocate#properties/id"
    },
    "name": {
      "$ref": "module://transfer-and-allocate#properties/name",
      "required": true,
      "disabledWhen": {
        "field": "#/properties/transferAllocateStatus",
        "notEquals": "Draft"
      }
    },
    "description": {
      "$ref": "module://transfer-and-allocate#properties/description",
      "disabledWhen": {
        "field": "#/properties/transferAllocateStatus",
        "notEquals": "Draft"
      }
    },
    "isDrs2BrokerTransferAllocate": {
      "$ref": "module://transfer-and-allocate#properties/isDrs2BrokerTransferAllocate",
      "default": false,
      "disabledWhen": {
        "field": "#/properties/transferAllocateStatus",
        "notEquals": "Draft"
      }
    },
    "submitted": {
      "type": "boolean",
      "title": "Submitted",
      "widget": "hidden",
      "default": false
    },
    "transferAllocateStatus": {
      "type": "string",
      "title": "Transfer Allocate Status",
      "widget": "hidden",
      "default": "Draft"
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_TRANSFER_ALLOCATE"
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "continue"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_TRANSFER_ALLOCATE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "lifecycle": {
        "dirtyGuard": true,
        "submitBehavior": "continue"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_TRANSFER_ALLOCATE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
